import request from '@/utils/request'

//  红线字词校验
export function redLineCheck (data) {
  return request({
    url: '/api/saas/mobile/sensitive/check.do',
    method: "POST",
    data,
  });
};





